import './CloseIcon.css';

// A geometric icon stays clear without a font or external icon dependency.
export default function CloseIcon() {
  return <svg className="og-close-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M5 5L19 19M19 5L5 19" />
  </svg>;
}
